import { gql } from 'urql';

const GroupedAgreements = gql`
  query GroupedAgreements($types: [ApplicationProductTypeEnum]!) {
    groupedAgreements(types: $types) {
      __typename
      id
      titleHTML
      agreements {
        __typename
        id
        title
        type
        resource {
          __typename
          htmlId
          pdfId
          htmlDocument {
            __typename
            id
            url
            format
          }
          pdfDocument {
            __typename
            id
            url
            format
          }
        }
        productType
      }
    }
  }
`;

export default GroupedAgreements;
